@use "@inshared/ui-foundation/css/tokens/color";
@use "@inshared/ui-foundation/css/tokens/typography/font-family";
@use "@inshared/ui-foundation/css/tokens/typography/font-size";
@use "@inshared/ui-foundation/css/tokens/spacing";
@use "@inshared/ui-foundation/css/tokens/size";
@use "@inshared/ui-foundation/css/tokens/border-width";
@use "@inshared/ui-foundation/css/tokens/border-radius";
@use "@inshared/ui-foundation/css/tokens/breakpoints";

web-top-menu {
    display: flex;
    height: min-content;
    align-self: center;

    .content {
        display: flex;
        &.hidden {
            display: none;
        }

        .auth-menu {
            --gap-auth-menu: 2.8rem;
            display: flex;
            align-items: center;

            @media (min-width: breakpoints.$screen-xl-min) {
                .item {
                    position: relative;
                    &:not(:nth-last-child(1 of .item)) {
                        margin-right: var(--gap-auth-menu);
                        &::after {
                            content: "";
                            position: absolute;
                            top: 50%;
                            right: calc(var(--gap-auth-menu) / 2 * -1);
                            transform: translateY(-50%);
                            height: 2rem;
                            border-right: border-width.$md solid color.$color-border-light;
                        }
                    }
                }
            }

            &:not(:defined) {
                .dropdown-menu,
                .personal-menu-item {
                    display: none;
                }
            }

            .mobile-menu-button {
                display: flex;
                height: 100%;

                .button {
                    --spacing-padding-block: #{spacing.$sm};
                    --spacing-padding-inline: 0;
                }
                .button.button-secondary {
                    --color-background: transparent;
                    --color-border: transparent;
                    --color-box-shadow: transparent;
                    --color-text: #{color.$color-primary};
                }
                web-icon.icon-start {
                    --icon-height: #{size.$icon-xl};
                    --icon-width: #{size.$icon-xl};
                }

                @media screen and (min-width: #{breakpoints.$screen-xl-min}) {
                    display: none;
                }
                &.mobile-menu-button-account web-icon.icon-start {
                    color: color.$color-dark;
                }
            }
        }

        a {
            text-decoration: none;
            color: color.$color-dark;
            padding: 1.2rem 0;

            &:hover {
                color: color.$color-primary;
            }
        }

        .item {
            display: flex;

            &.damage-item {
                display: none;
                @media (min-width: breakpoints.$screen-xl-min) {
                    display: block;
                }
            }

            &.personal-menu-item {
                display: block;
                position: relative;
            }

            &.personal-menu-item--new-menu {
                display: none;
                @media (min-width: breakpoints.$screen-xl-min) {
                    display: block;
                    position: relative;
                }
            }
        }

        web-icon {
            &.arrow-icon {
                --icon-height: #{size.$icon-xl};
                --icon-width: #{size.$icon-xl};
                position: absolute;
                top: 1.2rem;
                left: -3.2rem;
                color: color.$color-primary;
            }

            &.personal-data-icon,
            &.contact-icon {
                --icon-height: #{size.$icon-lg};
                --icon-width: #{size.$icon-lg};

                @media (min-width: breakpoints.$screen-xl-min) {
                    --icon-height: #{size.$icon-md};
                    --icon-width: #{size.$icon-md};
                }
            }

            &.open-menu-icon {
                --icon-height: #{size.$icon-xs};
                --icon-width: #{size.$icon-xs};
            }
        }

        .personal-menu {
            display: flex;
            align-items: center;
            text-decoration: none;
            position: relative;

            .insurance-map {
                display: none;
                position: absolute;
                bottom: 100%;
                transform: translateY(50%);
                color: color.$color-primary;
                font-family: font-family.$handwritten;
                font-size: font-size.$xxxl;

                .insurance-text {
                    white-space: nowrap;
                }

                @media (min-width: breakpoints.$screen-xl-min) {
                    display: block;
                }
            }

            .user-name {
                display: none;
                white-space: nowrap;
                font-size: font-size.$sm;

                @media (min-width: breakpoints.$screen-sm-min) {
                    display: block;
                }
            }
        }
    }
}

.dropdown-menu {
    position: absolute;
    z-index: 90;
    top: 3rem;
    padding: spacing.$lg spacing.$xxl;
    margin: spacing.$lg 0;
    min-width: 27rem;
    color: color.$color-dark;
    list-style: none;
    background-clip: padding-box;
    border: border-width.$md solid color.$color-primary;
    border-radius: border-radius.$xl;
    background-color: color.$color-white;
    right: 0;

    &:before {
        content: "";
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        top: -2.2rem;
        right: 2.6rem;
        border-style: solid;
        border-color: transparent;
        border-bottom-color: color.$color-primary;
        border-width: 1.1rem;
    }

    &:after {
        content: "";
        position: absolute;
        display: block;
        width: 0;
        height: 0;
        top: -1.9rem;
        right: 2.7rem;
        margin-left: -1rem;
        border-style: solid;
        border-color: transparent;
        border-bottom-color: color.$color-white;
        border-width: 1rem;
    }
    li {
        border-top: border-width.$sm solid color.$color-background-200;
        padding: 0.7rem spacing.$sm;

        &:first-child {
            border-top: none;
            padding-top: spacing.$lg;
        }

        &:last-child {
            padding-bottom: spacing.$lg;
        }

        a {
            width: 100%;
            text-decoration: none;
            color: color.$color-dark;
            padding: 0;

            &:hover {
                color: color.$color-primary;
            }
        }
    }
}
